if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        // this.init();
        FoxTheme.Motion.inView(this, this.init.bind(this));
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
          this.initImageZoom(allMedia);
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

       
      csUpdateThumbs(pswp, instant = false) {
        const wrap = pswp.scrollWrap && pswp.scrollWrap.querySelector('.pswp__custom-thumbnails');
        if (!wrap || wrap.hidden) return;
        const total = pswp.options.dataSource.length;
        const current = pswp.currIndex;
        const track = wrap.querySelector('.pswp__custom-thumbs-track');
        let active = null;
        wrap.querySelectorAll('.pswp__custom-thumb').forEach((thumb) => {
          const on = parseInt(thumb.dataset.index, 10) === current;
          thumb.classList.toggle('is-active', on);
          if (on) {
            thumb.setAttribute('aria-current', 'true');
            active = thumb;
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        if (track && active) {
          const left = active.offsetLeft - (track.clientWidth - active.offsetWidth) / 2;
          track.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
        }
        const count = wrap.querySelector('.pswp__custom-count');
        if (count) count.textContent = `${current + 1} / ${total}`;
        wrap.querySelectorAll('.pswp__custom-progress > span').forEach((seg) => {
          const i = parseInt(seg.dataset.index, 10);
          seg.classList.toggle('is-seen', i < current);
          seg.classList.toggle('is-active', i === current);
        });
      }

       
       
       
      csLayout(viewportSize, itemData, hasStrip = true) {
        const vw = viewportSize.x;
        const vh = viewportSize.y;
        const mobile = vw < 768;
        const side = mobile ? 16 : 24;
        const outer = mobile ? 16 : 20;
        const gap = 16;
        const buttons = 60;
        const stripH = hasStrip ? (mobile ? 122 : 156) : 0;
        const stripGap = hasStrip ? gap : 0;
        const areaW = vw - side * 2;
        const square = Math.max(0, Math.min(areaW, vh - outer * 2 - stripH - stripGap - gap - buttons));
        const group = stripH + stripGap + square + gap + buttons;
        const outerTop = Math.max(outer, (vh - group) / 2);
        const top = outerTop + stripH + stripGap;
        const ratio = itemData && itemData.width && itemData.height ? itemData.height / itemData.width : 1;
        const itemH = Math.max(0, Math.min(areaW * ratio, vh - top - gap - buttons - outer));
        return { side, outerTop, top, bottom: Math.max(0, vh - top - itemH), itemH };
      }

       
      csPlaceButtons(pswp) {
        const bar = pswp.topBar;
        const slide = pswp.currSlide;
        const strip = pswp.scrollWrap && pswp.scrollWrap.querySelector('.pswp__custom-thumbnails');
        const hasStrip = !!(strip && !strip.hidden);
        const box = this.csLayout(pswp.viewportSize, null, hasStrip);
        if (hasStrip) strip.style.top = `${Math.round(box.outerTop)}px`;
         
        if (pswp.element) {
          pswp.element.style.setProperty('--cs-media-top', `${Math.round(box.top)}px`);
          pswp.element.style.setProperty('--cs-media-size', `${Math.round(box.itemH)}px`);
        }
        if (!bar || !slide || !slide.data) return;
        const data = slide.data.width && slide.data.height ? slide.data : { width: 1, height: 1 };
        const vw = pswp.viewportSize.x;
        const vh = pswp.viewportSize.y;
        const pad = pswp.options.paddingFn(pswp.viewportSize, data, pswp.currIndex);
        const areaW = vw - pad.left - pad.right;
        const areaH = vh - pad.top - pad.bottom;
        const shownH = Math.min(areaH, (areaW * data.height) / data.width);
        const pictureBottom = pad.top + areaH / 2 + shownH / 2;
         
        const firstButton = bar.querySelector('button');
        const inset = firstButton ? Math.max(0, (bar.offsetHeight - 60) / 2) : 0;
        const barH = bar.offsetHeight || 60;
        const top = Math.min(pictureBottom + 16 - inset, vh - barH - 16 + inset);
        bar.style.top = `${Math.round(top)}px`;
        bar.style.bottom = 'auto';
      }

       
       
      csBounce(pswp) {
        if (!pswp.opener || !pswp.opener.isOpen) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const index = pswp.currIndex;
        if (index >= pswp.getNumItems() - 1) return;
        pswp.csBounced = pswp.csBounced || new Set();
        if (pswp.csBounced.has(index)) return;
        pswp.csBounced.add(index);
        this.csStopBounce(pswp);
        pswp.csBounceBase = null;
        const duration = 900;
        const depth = Math.min(64, pswp.viewportSize.x * 0.14);
        const earliest = performance.now() + 350;
        let start = 0;
        let base = 0;
        const run = (now) => {
          if (pswp.currIndex !== index || !pswp.opener.isOpen) {
            pswp.csBounceFrame = null;
            return;
          }
          if (!start) {
             
            const busy = pswp.animations && pswp.animations.activeAnimations && pswp.animations.activeAnimations.length;
            if (now < earliest || busy) {
              pswp.csBounceFrame = requestAnimationFrame(run);
              return;
            }
            start = now;
            base = pswp.mainScroll.x;
            pswp.csBounceBase = base;
          }
          const t = (now - start) / duration;
          if (t >= 1) {
            pswp.mainScroll.moveTo(base);
            pswp.csBounceFrame = null;
            pswp.csBounceBase = null;
            return;
          }
          pswp.mainScroll.moveTo(base - depth * Math.sin(Math.PI * t) * (1 - t * 0.35));
          pswp.csBounceFrame = requestAnimationFrame(run);
        };
        pswp.csBounceFrame = requestAnimationFrame(run);
      }

      csStopBounce(pswp, restore = false) {
        if (pswp.csBounceFrame) {
           
          cancelAnimationFrame(pswp.csBounceFrame);
          pswp.csBounceFrame = null;
          if (restore && typeof pswp.csBounceBase === 'number') pswp.mainScroll.moveTo(pswp.csBounceBase);
        }
      }

      initImageZoom(items = []) {
        let dataSource = [];
        if (items.length > 0) {
          items.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                  thumb: media.dataset.pswpThumb,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                  thumb: media.dataset.pswpThumb,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                  thumb: media.dataset.pswpThumb,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
          preload: [1, 4],
           
           
          spacing: 0.04,
          paddingFn: (viewportSize, itemData) => {
            const l = this.csLayout(viewportSize, itemData, dataSource.length > 1);
            return { top: l.top, bottom: l.bottom, left: l.side, right: l.side };
          },
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data }) => {
          if (data.src) {
            return data.src;
          }
          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);

          if (this.lightbox.pswp && this.lightbox.pswp.scrollWrap) {
             
             
            this.csUpdateThumbs(this.lightbox.pswp);
            this.csPlaceButtons(this.lightbox.pswp);
            this.csBounce(this.lightbox.pswp);
          }
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });

          this.lightbox.pswp.ui.registerElement({
            name: 'custom-thumbnails',
            order: 9,
            isButton: false,
            appendTo: 'wrapper',
            html: '',
            onInit: (el, pswp) => {
               
               
              const total = pswp.options.dataSource.length;
              el.className = 'pswp__custom-thumbnails';
              if (total < 2) {
                el.hidden = true;
                return;
              }
              let thumbHtml = '';
              pswp.options.dataSource.forEach((item, index) => {
                if (item.thumb) {
                  thumbHtml += `<button type="button" class="pswp__custom-thumb" data-index="${index}" aria-label="Show picture ${index + 1} of ${total}"><img src="${item.thumb}" alt="" loading="lazy" width="150" height="150" /></button>`;
                }
              });
              el.innerHTML = `<div class="pswp__custom-thumbs-track">${thumbHtml}</div><div class="pswp__custom-position"><span class="pswp__custom-progress" aria-hidden="true">${pswp.options.dataSource.map((d, i) => `<span data-index="${i}"></span>`).join('')}</span><span class="pswp__custom-count" aria-live="polite"></span></div>`;

              el.querySelectorAll('.pswp__custom-thumb').forEach((thumb) => {
                thumb.addEventListener('click', (e) => {
                  pswp.goTo(parseInt(e.currentTarget.dataset.index, 10));
                });
              });
              requestAnimationFrame(() => {
                this.csPlaceButtons(pswp);
                this.csUpdateThumbs(pswp, true);
              });
              pswp.on('resize', () => this.csPlaceButtons(pswp));
              pswp.on('openingAnimationEnd', () => {
                this.csPlaceButtons(pswp);
                this.csBounce(pswp);
              });
              pswp.on('pointerDown', () => this.csStopBounce(pswp, true));
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

        if (this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1, 0, false);
        } else {
          this.sortMediaItems(variant);
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        this.initImageZoom(newMedias);

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
